var SwapFromElement_1;
import { __decorate, __metadata } from "tslib";
import { EmbeddedConfigToken } from '@1inch-community/core/application-context';
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { observe, translate } from '@1inch-community/core/lit-utils';
import { SwapContextToken } from '@1inch-community/sdk/swap';
import '@1inch-community/ui-components/button';
import '@1inch-community/ui-components/card';
import '@1inch-community/ui-components/icon';
import { consume } from '@lit/context';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { combineLatest, defer, distinctUntilChanged, map, startWith } from 'rxjs';
import './elements';
import { swapFromStyle } from './swap-from.style';
let SwapFromElement = class SwapFromElement extends LitElement {
    constructor() {
        super(...arguments);
        this.applicationContext = lazyAppContextConsumer(this);
        this.fusionView$ = combineLatest([
            defer(() => this.applicationContext.value.wallet.data.activeAddress$),
            defer(() => this.swapContext.getTokenByType('source')),
            defer(() => this.swapContext.getTokenByType('destination')),
        ]).pipe(map(([address, sourceToken, destinationToken]) => !address || !sourceToken || !destinationToken), startWith(SwapFromElement_1.lastFusionRenderIsEmptyState), distinctUntilChanged(), map((isEmpty) => {
            SwapFromElement_1.lastFusionRenderIsEmptyState = isEmpty;
            if (isEmpty)
                return html ``;
            return html `<inch-fusion-swap-info></inch-fusion-swap-info>`;
        }));
    }
    static { SwapFromElement_1 = this; }
    static { this.tagName = 'inch-swap-form'; }
    static { this.styles = swapFromStyle; }
    static { this.lastFusionRenderIsEmptyState = true; }
    render() {
        if (!this.swapContext)
            return;
        return html `
      <div class="swap-form-container">
        <inch-card-header
          headerText="${translate('widgets.swap-form.header.swap')}"
          headerTextPosition="left"
        >
          <slot name="header" slot="right-container"></slot>
        </inch-card-header>

        <div class="input-container">
          <inch-swap-form-input tokenType="source"></inch-swap-form-input>
          <inch-token-pair-switch></inch-token-pair-switch>
          <inch-swap-form-input disabled tokenType="destination"></inch-swap-form-input>
        </div>

        ${observe(this.fusionView$)}

        <inch-swap-button></inch-swap-button>
      </div>
    `;
    }
};
__decorate([
    consume({ context: SwapContextToken, subscribe: true }),
    __metadata("design:type", Object)
], SwapFromElement.prototype, "swapContext", void 0);
__decorate([
    consume({ context: EmbeddedConfigToken }),
    __metadata("design:type", Object)
], SwapFromElement.prototype, "config", void 0);
SwapFromElement = SwapFromElement_1 = __decorate([
    customElement(SwapFromElement.tagName)
], SwapFromElement);
export { SwapFromElement };
//# sourceMappingURL=swap-from.element.js.map